module.exports = __webpack_public_path__ + "img/Mb_Lobby_Video.7d7fcabb.jpg";